import { CSSObject } from '@chakra-ui/react';
import cards from '../../../../../../assets/betroyale/images/header/cards.svg';
import { CustomButtonProps } from '@/components/Button/Button';

export const BoxBallance: CSSObject = {
  bgGradient: 'linear(to-b, alpha.800, alpha.900)',
  mx: '1',
  borderBottomRadius: 'base',
  '> div:first-of-type': {
    color: 'beta.500',
    '> p': {
      fontSize: 'md',
      fontWeight: 'medium',
    },
    '> div': {
      '> p': {
        fontSize: 'md',
      },
    },
  },
  '> div:last-of-type': {
    color: 'white',
    '> p': {
      fontSize: 'md',
      fontWeight: 'medium',
    },
    '> div': {
      '> p': {
        fontSize: 'md',
      },
    },
  },
};

export const buttonDepositProps: CustomButtonProps = {
  variant: 'secondary',
  textShadow: '0px 1px 2px rgba(0, 0, 0, 0.40)',
  w: 'full',
  mt: '2',
  sx: {
    '&&': {
      _hover: {
        bgGradient: 'linear(to-b, alpha.800, alpha.900)',
        boxShadow:
          '0px 0px 0px 2px #FFA902 inset, 0px 0px 0px 4px #0C2549 inset, 0px 0px 0px 5px #4d98c5 inset',
      },
    },
    '& svg': {
      textShadow: '0px 1px 2px rgba(0, 0, 0, 0.40)',
      mb: '1',
    },
  },
};

export const ButtonNavItem = (): CSSObject => ({
  bg: 'white',
  color: 'gray.700',
  borderTop: '1px',
  borderColor: 'gamma.200',

  '&& > p': { transition: 'all 0.2s ease-in-out' },
  ':first-child': {
    borderTop: 'none',
  },
  '&:hover, &:active': {
    p: { transform: 'translate(2px, 0)' },
    bg: 'gray.100',
  },
});

export const BoxMascotImage: CSSObject = {
  bgImage: `url(${cards})`,
  bgSize: '97% auto',
  bgPos: 'inherit',
  bgRepeat: 'no-repeat',
  zIndex: '-1',
  display: ['none', null, null, null, 'block'],
  w: '40',
  h: '32',
  pos: 'absolute',
  bottom: '-12',
  left: '2',
};

export const PopoverHeaderQA: CSSObject = {
  bg: 'alpha.800',
  mx: '1',
  mt: '1',
  border: 'none',
  borderTopRadius: 'base',
  pb: '0',
  color: 'white',
  lineHeight: 'normal',
};

export const PopoverContentQA: CSSObject = {
  bg: 'white',
  boxShadow: '2xl',
  _focus: {
    boxShadow: '2xl',
  },
};

export const FlexBallanceItem: CSSObject = {
  color: 'white',

  p: {
    _last: { fontWeight: 'extrabold' },
  },
};

export const TextBalanceValue: CSSObject = {
  color: 'alpha.500',
  textShadow: '0px 2px 3px rgba(0, 0, 0, 0.2)',
  fontSize: 'sm',
  fontWeight: 'extrabold',
};

export const TextQuickAccessHello: CSSObject = {
  fontSize: 'sm',
};

export const buttonBalanceProps: CustomButtonProps = {
  variant: 'unstyled',
  display: 'flex',
  fontSize: 'sm',
};
